import { render, staticRenderFns } from "./CreditCard.vue?vue&type=template&id=48c1d180&scoped=true&"
import script from "./CreditCard.vue?vue&type=script&lang=js&"
export * from "./CreditCard.vue?vue&type=script&lang=js&"
import style0 from "./CreditCard.vue?vue&type=style&index=0&id=48c1d180&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c1d180",
  null
  
)

export default component.exports